var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-overlay',{attrs:{"value":_vm.loading}},[_c('Spinner',{attrs:{"size":"huge","line-fg-color":"#204281"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }